<div class="report-snackbar">
  <mat-icon class="report-snackbar__icon">description</mat-icon>
  <span class="report-snackbar__message">{{ data.message }}</span>
  <div class="report-snackbar__actions">
    <button mat-button class="report-snackbar__btn report-snackbar__btn--view" (click)="viewReport()">View Report</button>
    <button mat-button class="report-snackbar__btn" (click)="dismiss()">Dismiss</button>
  </div>
</div>
